// @flow
import React, { useState, useEffect } from 'react';

import Card from '../../../components/Cards/Card';

import styles from './ArticlesSave.module.scss';
import getDataht from '../../../controllers/handtips.controller';

type IHT = {
  header: {
    imageUrl: string;
    textheader: string;
  };

  Content: {
    blockOne: {
      localHeaderbone: string;
      textboone: string;
      blockHeaderbo: string;
      textbotwo: string;
      textbothree: string;
      textbofour: string;
    };
    blockTwo: {
      blockHeaderbtwo: string;
      textbtwoone: string;
      textbtwoonee: string;
      textbtwotwo: string;
      textbtwotwoo: string;
      textbtwotwooo: string;
      textbtwotwoooo: string;
      textbtwotwooooo: string;
      textbtwotwoooooo: string;
      textbtwothree: string;
    };
    blockThree: {
      localHeaderbthree: string;
      textbtone: string;
      textbtonee: string;
      textbtoneee: string;
      textbtoneeee: string;
      textbtoneeeee: string;
      textbtoneeeeee: string;
      textbttwo: string;
      textbtthree: string;
      textbtthreee: string;
      textbtthreeee: string;
      textbtfour: string;
      textbtfourr: string;
      textbtfive: string;
      textbtsix: string;
      textbtseven: string;
      textbtsevenn: string;
      textbteight: string;
      textbtnine: string;
      textbtten: string;
      textbteleven: string;
      textbttwelve: string;
      textbtthirteen: string;
      textbtfourteen: string;
      textbtfifteen: string;
    };
    blockFour: {
      localHeaderbfour: string;
      textbfone: string;
      textbfonee: string;
      textbfoneee: string;
      textbffour: string;
      textbffive: string;
    };
  };
} | null

const Handtips = () => {
  const [language, setLanguage] = useState<string>('');

  const [data, setData] = useState<IHT>({});

  const getLanguage = () => {
    const locale = localStorage.getItem('i18nextLng');
    let languageKey;
    switch (locale) {
      case 'en':
        languageKey = 'Eng';
        break;
      case 'ru':
        languageKey = 'Rus';
        break;
      default:
        languageKey = 'Rus';
    }
    return languageKey;
  };

  useEffect(() => {
    setLanguage(getLanguage());
  }, []);

  const handleRes = async () => {
    const res = await getDataht(getLanguage());

    setData(res);
  };

  useEffect(() => {
    handleRes();
  }, []);

  if (!data) return null;

  return (
    language
    && (
    <>
      <title>OmahaPro</title>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="true"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Staatliches&display=swap"
        rel="stylesheet"
      />
      <div id="root" className={styles.site}>
        <div className={styles.container}>
          <div className={styles.header}>
            <span className={styles.header_text}>{data?.header?.textheader}</span>
          </div>

          <div className={styles.content}>
            <div className={styles.block}>
              <span className={styles.local_header}>
                {data.Content?.blockOne?.localHeaderbone}
              </span>
              <span className={styles.text}>
                {data.Content?.blockOne?.textboone}
              </span>
            </div>

            <div className={styles.block}>
              <span className={styles.block_header}>
                {data.Content?.blockOne?.blockHeaderbo}
              </span>
              <span className={styles.text}>
                {data.Content?.blockOne?.textbotwo}
              </span>
              <div className={styles.card_box}>
                <div className={styles.hand}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="kresti" bg="green" size="big" value="J" />
                  <Card mast="picki" bg="black" size="big" value="2" />
                </div>
                <div className={styles.hand}>
                  <Card mast="bubi" bg="grey" size="big" value="Q" />
                  <Card mast="bubi" bg="grey" size="big" value="J" />
                  <Card mast="chervi" bg="red" size="big" value="8" />
                  <Card mast="bubi" bg="grey" size="big" value="7" />
                </div>
                <div className={styles.hand}>
                  <Card mast="picki" bg="black" size="big" value="9" />
                  <Card mast="bubi" bg="grey" size="big" value="8" />
                  <Card mast="picki" bg="black" size="big" value="7" />
                  <Card mast="bubi" bg="grey" size="big" value="6" />
                </div>
                <div className={styles.hand}>
                  <Card mast="chervi" bg="red" size="big" value="J" />
                  <Card mast="chervi" bg="red" size="big" value="9" />
                  <Card mast="chervi" bg="red" size="big" value="8" />
                  <Card mast="chervi" bg="red" size="big" value="7" />
                </div>
                <div className={styles.hand}>
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="picki" bg="black" size="big" value="Q" />
                  <Card mast="bubi" bg="grey" size="big" value="J" />
                  <Card mast="kresti" bg="green" size="big" value="T" />
                </div>
              </div>
              <div className={styles.column_block}>
                <div className={`${styles.line_block} ${styles.text}`}>
                  <span>{data?.Content?.blockOne?.textbothree}</span>
                  <span className={styles.line}>
                    <Card mast="no" bg="blank" size="small" value="A" />
                    <span>-high </span>
                    <Card mast="no" bg="blank" size="small" value="Q" />
                    <span>-high</span>
                    <Card mast="no" bg="blank" size="small" value="9" />
                    <span>-high</span>
                    <Card mast="no" bg="blank" size="small" value="J" />
                    <span>-high</span>
                    <Card mast="no" bg="blank" size="small" value="K" />
                    <span>-high</span>
                  </span>
                  <span>{data?.Content?.blockOne?.textbofour}</span>
                </div>
              </div>
            </div>
            <div className={styles.sum}>
              <div className={styles.block_sum}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="A" />
                  <Card mast="no" bg="blank" size="big" value="K" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="J" />
                  <Card mast="no" bg="blank" size="big" value="2" />
                </div>
              </div>
              <div className={styles.block_sum}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="Q" />
                  <Card mast="no" bg="blank" size="big" value="J" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="8" />
                  <Card mast="no" bg="blank" size="big" value="7" />
                </div>
              </div>
              <div className={styles.block_sum}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="9" />
                  <Card mast="no" bg="blank" size="big" value="8" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="7" />
                  <Card mast="no" bg="blank" size="big" value="6" />
                </div>
              </div>
              <div className={styles.block_sum}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="J" />
                  <Card mast="no" bg="blank" size="big" value="9" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="8" />
                  <Card mast="no" bg="blank" size="big" value="7" />
                </div>
              </div>
              <div className={styles.block_sum}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="K" />
                  <Card mast="no" bg="blank" size="big" value="Q" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="J" />
                  <Card mast="no" bg="blank" size="big" value="T" />
                </div>
              </div>
            </div>

            <div className={styles.block}>
              <span className={styles.block_header}>
                {data?.Content?.blockTwo?.blockHeaderbtwo}
              </span>
              <span className={styles.text}>
                {data?.Content?.blockTwo?.textbtwoone}
              </span>

              <div className={styles.card_box}>
                <div className={styles.hand}>
                  <Card mast="chervi" bg="red" size="big" value="8" />
                  <Card mast="picki" bg="black" size="big" value="8" />
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="bubi" bg="grey" size="big" value="K" />
                </div>

                <div className={styles.hand}>
                  <Card mast="picki" bg="black" size="big" value="2" />
                  <Card mast="bubi" bg="grey" size="big" value="2" />
                  <Card mast="bubi" bg="grey" size="big" value="K" />
                  <Card mast="picki" bg="black" size="big" value="J" />
                </div>

                <div className={styles.hand}>
                  <Card mast="picki" bg="black" size="big" value="J" />
                  <Card mast="chervi" bg="red" size="big" value="J" />
                  <Card mast="chervi" bg="red" size="big" value="9" />
                  <Card mast="kresti" bg="green" size="big" value="9" />
                </div>

                <div className={styles.hand}>
                  <Card mast="chervi" bg="red" size="big" value="5" />
                  <Card mast="bubi" bg="grey" size="big" value="5" />
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="bubi" bg="grey" size="big" value="K" />
                </div>

                <div className={styles.hand}>
                  <Card mast="kresti" bg="green" size="big" value="T" />
                  <Card mast="picki" bg="black" size="big" value="T" />
                  <Card mast="bubi" bg="grey" size="big" value="A" />
                  <Card mast="kresti" bg="green" size="big" value="Q" />
                </div>
              </div>
              <span className={styles.text}>
                {data?.Content?.blockTwo?.textbtwotwo}
              </span>
              <div className={styles.sum}>
                <div className={styles.big_block_sum}>
                  <div className={styles.two_cards}>
                    <Card mast="no" bg="blank" size="big" value="8" />
                    <Card mast="no" bg="blank" size="big" value="8" />
                  </div>
                  <span className={styles.small_sum_tex}>
                    {'+'}
                    {data?.Content?.blockTwo?.textbtwotwoo}
                    {'Side cards'}
                  </span>
                  <div className={styles.two_cards}>
                    <Card mast="no" bg="blank" size="big" value="A" />
                    <Card mast="no" bg="blank" size="big" value="K" />
                  </div>
                </div>
                <div className={styles.big_block_sum}>
                  <div className={styles.two_cards}>
                    <Card mast="no" bg="blank" size="big" value="2" />
                    <Card mast="no" bg="blank" size="big" value="2" />
                  </div>
                  <span className={styles.small_sum_tex}>
                    {'+'}
                    {data?.Content?.blockTwo?.textbtwotwooo}
                    {'Side cards'}
                  </span>
                  <div className={styles.two_cards}>
                    <Card mast="no" bg="blank" size="big" value="K" />
                    <Card mast="no" bg="blank" size="big" value="J" />
                  </div>
                </div>
                <div className={styles.big_block_sum}>
                  <div className={styles.two_cards}>
                    <Card mast="no" bg="blank" size="big" value="J" />
                    <Card mast="no" bg="blank" size="big" value="J" />
                  </div>
                  <span className={styles.small_sum_tex}>
                    {'+'}
                    {data?.Content?.blockTwo?.textbtwotwoooo}
                    {'Side cards'}
                  </span>
                  <div className={styles.two_cards}>
                    <Card mast="no" bg="blank" size="big" value="9" />
                    <Card mast="no" bg="blank" size="big" value="9" />
                  </div>
                </div>
                <div className={styles.big_block_sum}>
                  <div className={styles.two_cards}>
                    <Card mast="no" bg="blank" size="big" value="5" />
                    <Card mast="no" bg="blank" size="big" value="5" />
                  </div>
                  <span className={styles.small_sum_tex}>
                    {'+'}
                    {data?.Content?.blockTwo?.textbtwotwooooo}
                    {'Side cards'}
                  </span>
                  <div className={styles.two_cards}>
                    <Card mast="no" bg="blank" size="big" value="A" />
                    <Card mast="no" bg="blank" size="big" value="K" />
                  </div>
                </div>
                <div className={styles.big_block_sum}>
                  <div className={styles.two_cards}>
                    <Card mast="no" bg="blank" size="big" value="T" />
                    <Card mast="no" bg="blank" size="big" value="T" />
                  </div>
                  <span className={styles.small_sum_tex}>
                    {'+'}
                    {data?.Content?.blockTwo?.textbtwotwoooooo}
                    {'Side cards'}
                  </span>
                  <div className={styles.two_cards}>
                    <Card mast="no" bg="blank" size="big" value="A" />
                    <Card mast="no" bg="blank" size="big" value="Q" />
                  </div>
                </div>
              </div>
              <div className={`${styles.column_block} ${styles.text}`}>
                <div className={styles.line_block}>
                  <span>{data?.Content?.blockTwo?.textbtwothree}</span>
                  <Card mast="no" bg="blank" size="small" value="J" />
                  <Card mast="no" bg="blank" size="small" value="J" />
                  {' '}
                  +
                  <Card mast="no" bg="blank" size="small" value="9" />
                  <Card mast="no" bg="blank" size="small" value="9" />
                </div>
              </div>
            </div>

            <div className={styles.block}>
              <span className={styles.local_header}>
                {data?.Content?.blockThree?.localHeaderbthree}
              </span>
              <div className={styles.line_block}>
                <span className={styles.text}>
                  {data?.Content?.blockThree?.textbtone}
                  <span className={`${styles.text} ${styles.single_suit}`}>
                    Single Suited
                  </span>
                  {', '}
                  <span className={`${styles.text} ${styles.good_suit}`}>
                    Double Suited
                  </span>
                  {', Rainbow'}
                  {data?.Content?.blockTwo?.textbtwoonee}
                  {'Mono.'}
                </span>
                <span className={`${styles.text} ${styles.single_suit}`}>
                  Single Suited
                </span>
                <span className={styles.text}>
                  {data?.Content?.blockThree?.textbtonee}
                </span>
                <span className={styles.text}>
                  <span className={`${styles.text} ${styles.good_suit}`}>
                    Double Suited
                  </span>
                  {data?.Content?.blockThree?.textbtoneee}
                  <br />
                  {'Rainbow'}
                  {data?.Content?.blockThree?.textbtoneeee}
                  <br />
                  {'Mono'}
                  {data?.Content?.blockThree?.textbtoneeeee}
                  <br />
                  {data?.Content?.blockThree?.textbtoneeeeee}
                </span>
              </div>
              <div className={`${styles.text} ${styles.column_block}`}>
                <span className={styles.line_block}>
                  {data?.Content?.blockThree?.textbttwo}
                  <div className={styles.small_hand}>
                    <Card mast="no" bg="blank" size="small" value="A" />
                    <Card mast="no" bg="blank" size="small" value="K" />
                    <Card mast="no" bg="blank" size="small" value="Q" />
                    <Card mast="no" bg="blank" size="small" value="2" />
                  </div>
                  <span>
                    {data?.Content?.blockThree?.textbtthree}
                    <span className={styles.single_suit}>
                      {' Single Suited '}
                    </span>
                    {data?.Content?.blockThree?.textbtthreee}
                  </span>
                </span>
                <div className={styles.card_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card mast="chervi" bg="red" size="big" value="K" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="Q"
                    />
                    <Card
                      mast="picki"
                      bg="black"
                      size="big"
                      value="2"
                    />
                  </div>

                  <div className={styles.hand}>
                    <Card
                      mast="picki"
                      bg="black"
                      size="big"
                      value="A"
                    />
                    <Card mast="chervi" bg="red" size="big" value="K" />
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="2"
                    />
                  </div>

                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card mast="chervi" bg="red" size="big" value="K" />
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card
                      mast="picki"
                      bg="black"
                      size="big"
                      value="2"
                    />
                  </div>

                  <div className={styles.hand}>
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="A"
                    />
                    <Card mast="chervi" bg="red" size="big" value="K" />
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card mast="chervi" bg="red" size="big" value="2" />
                  </div>
                </div>
              </div>
              <div className={`${styles.text} ${styles.column_block}`}>
                <span>
                  {data?.Content?.blockThree?.textbtfour}
                  <span className={styles.good_suit}>Double Suited</span>
                  {data?.Content?.blockThree?.textbtfourr}
                </span>
                <div className={styles.card_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card mast="chervi" bg="red" size="big" value="K" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="Q"
                    />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="2"
                    />
                  </div>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="K"
                    />
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="2"
                    />
                  </div>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="K"
                    />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="Q"
                    />
                    <Card mast="chervi" bg="red" size="big" value="2" />
                  </div>
                </div>
              </div>
              <div className={`${styles.text} ${styles.column_block}`}>
                {data?.Content?.blockThree?.textbtfive}
                <div className={styles.card_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card
                      mast="picki"
                      bg="black"
                      size="big"
                      value="K"
                    />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="Q"
                    />
                    <Card mast="bubi" bg="grey" size="big" value="2" />
                  </div>
                </div>
              </div>
              <div className={`${styles.text} ${styles.column_block}`}>
                {data?.Content?.blockThree?.textbtsix}
                <div className={styles.card_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card mast="chervi" bg="red" size="big" value="K" />
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card mast="chervi" bg="red" size="big" value="2" />
                  </div>
                  <div className={styles.hand}>
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="A"
                    />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="K"
                    />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="Q"
                    />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="2"
                    />
                  </div>
                </div>
              </div>
              <div className={`${styles.text} ${styles.line_block}`}>
                <span>
                  {data?.Content?.blockThree?.textbtseven}
                  <span className={styles.single_suit}>Single Suited</span>
                  {', '}
                  <span className={styles.good_suit}>Double Suited</span>
                  {data?.Content?.blockThree?.textbtsevenn}
                </span>
                <Card mast="no" bg="blank" size="small" value="9" />
                <Card mast="no" bg="blank" size="small" value="9" />
                <Card mast="no" bg="blank" size="small" value="A" />
                <Card mast="no" bg="blank" size="small" value="K" />
              </div>
              <div className={`${styles.text} ${styles.column_block}`}>
                <span>
                  <span className={styles.single_suit}>Single Suited</span>
                  {data?.Content?.blockThree?.textbteight}
                </span>
                <div className={styles.card_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="9" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="9"
                    />
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card mast="bubi" bg="grey" size="big" value="K" />
                  </div>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="9" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="9"
                    />
                    <Card
                      mast="picki"
                      bg="black"
                      size="big"
                      value="A"
                    />
                    <Card mast="chervi" bg="red" size="big" value="K" />
                  </div>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="9" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="9"
                    />
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card mast="chervi" bg="red" size="big" value="K" />
                  </div>
                </div>
              </div>
              <div className={`${styles.text} ${styles.column_block}`}>
                <span>
                  <span className={styles.good_suit}>Double Suited</span>
                  {data?.Content?.blockThree?.textbtnine}
                </span>
                <div className={styles.card_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="9" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="9"
                    />
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="K"
                    />
                  </div>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="9" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="9"
                    />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="A"
                    />
                    <Card mast="chervi" bg="red" size="big" value="K" />
                  </div>
                </div>
              </div>
              <div className={`${styles.text} ${styles.column_block}`}>
                {data?.Content?.blockThree?.textbtten}
                <div className={styles.card_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="9" />
                    <Card
                      mast="picki"
                      bg="black"
                      size="big"
                      value="9"
                    />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="A"
                    />
                    <Card mast="bubi" bg="grey" size="big" value="K" />
                  </div>
                  <div className={styles.hand}>
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="9"
                    />
                    <Card
                      mast="picki"
                      bg="black"
                      size="big"
                      value="9"
                    />
                    <Card mast="bubi" bg="grey" size="big" value="A" />
                    <Card mast="chervi" bg="red" size="big" value="K" />
                  </div>
                </div>
              </div>
              <div className={`${styles.text} ${styles.exp}`}>
                <span>
                  {data?.Content?.blockThree?.textbteleven}
                  <span>
                    <div className={styles.small_hand}>
                      <Card
                        mast="no"
                        bg="blank"
                        size="small"
                        value="J"
                      />
                      <Card
                        mast="no"
                        bg="blank"
                        size="small"
                        value="J"
                      />
                      <Card
                        mast="no"
                        bg="blank"
                        size="small"
                        value="9"
                      />
                      <Card
                        mast="no"
                        bg="blank"
                        size="small"
                        value="9"
                      />
                    </div>
                  </span>
                </span>
              </div>
              <div className={`${styles.text} ${styles.column_block}`}>
                <span>
                  <span className={styles.single_suit}>Single Suited</span>
                  {data?.Content?.blockThree?.textbttwelve}
                </span>
                <div className={styles.card_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="J" />
                    <Card mast="bubi" bg="grey" size="big" value="J" />
                    <Card mast="chervi" bg="red" size="big" value="9" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="9"
                    />
                  </div>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="J" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="J"
                    />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="9"
                    />
                    <Card mast="bubi" bg="grey" size="big" value="9" />
                  </div>
                </div>
              </div>
              <div className={`${styles.text} ${styles.column_block}`}>
                <span>
                  <span className={styles.good_suit}>Double Suited</span>
                  {data?.Content?.blockThree?.textbtthirteen}
                </span>
                <div className={styles.card_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="J" />
                    <Card mast="bubi" bg="grey" size="big" value="J" />
                    <Card mast="chervi" bg="red" size="big" value="9" />
                    <Card mast="bubi" bg="grey" size="big" value="9" />
                  </div>
                  <div className={styles.hand}>
                    <Card
                      mast="picki"
                      bg="black"
                      size="big"
                      value="J"
                    />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="J"
                    />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="9"
                    />
                    <Card
                      mast="picki"
                      bg="black"
                      size="big"
                      value="9"
                    />
                  </div>
                </div>
              </div>
              <div className={`${styles.text} ${styles.column_block}`}>
                {data?.Content?.blockThree?.textbtfourteen}
                <div className={styles.card_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="J" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="J"
                    />
                    <Card
                      mast="picki"
                      bg="black"
                      size="big"
                      value="9"
                    />
                    <Card mast="bubi" bg="grey" size="big" value="9" />
                  </div>
                  <div className={styles.hand}>
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="J"
                    />
                    <Card
                      mast="picki"
                      bg="black"
                      size="big"
                      value="J"
                    />
                    <Card mast="chervi" bg="red" size="big" value="9" />
                    <Card mast="bubi" bg="grey" size="big" value="9" />
                  </div>
                </div>
              </div>
              <div className={styles.text}>
                {data?.Content?.blockThree?.textbtfifteen}
              </div>
            </div>
            <div className={styles.block}>
              <span className={styles.local_header}>
                {data?.Content?.blockFour?.localHeaderbfour}
              </span>
              <span className={styles.text}>
                {data?.Content?.blockFour?.textbfone}
                <span className={styles.good_suit}>Double</span>
                {data?.Content?.blockFour?.textbfonee}
                <span className={styles.single_suit}>Single Suited </span>
                {data?.Content?.blockFour?.textbfoneee}
              </span>
              <div className={`${styles.suit_block} ${styles.good_suit}`}>
                <span className={styles.num}>{1}</span>
                <span>Double Suited</span>
              </div>
              <div className={`${styles.suit_block} ${styles.single_suit}`}>
                <span className={styles.num}>{2}</span>
                <span>Single Suited</span>
              </div>
              <div className={`${styles.suit_block} ${styles.mono_suit}`}>
                <span className={styles.num}>{3}</span>
                <span>Mono</span>
              </div>
              <div className={`${styles.suit_block} ${styles.text}`}>
                <span className={styles.num}>{4}</span>
                <span>Rainbow</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
    )
  );
};

export default Handtips;
